/*global loadmore_params */

'use strict';

(function () {
    $(function () {
        main();
    });

    function main() {
        setupMenu();
        setupSearch();
        setupLoadMoreButton();

        setupGalleries();
        
        setupImages(".content", true);
        setupImages(".featured-image-link", false);

        setupAds();
    }

    function setupAds() {
        let $adcont = $(".ad-container ul");

        $adcont.each(function() {
            let $cont = this;

            setInterval(function() {
                changeActiveAd($cont);
            }, 10000);
        });

        function changeActiveAd(container) {
            let $ads = $("li", container);
            if ($ads.length <= 1) {
                return;
            }

            let setActive = false;
            let activeSet = false;

            $ads.each(function(){
                let $curel = $(this);
                
                if (setActive) {
                    $curel.addClass("active");
                    activeSet = true;
                    return false;
                }

                if ($curel.hasClass("active")) {
                    $curel.removeClass("active");
                    setActive = true;
                }
            });

            if (setActive && !activeSet) {
                $ads.first().addClass("active");
            }
        }
    }

    function setupGalleries() {
        $(".gallery .gallery-images ul").lightGallery({
            selector: '.gallery-image',
            thumbnail: true,
            showThumbByDefault: false,
            mode: 'lg-tube',
            hideBarsDelay: 3000,
            cssEasing: 'cubic-bezier(0.455, 0.030, 0.515, 0.955)',
            download: false
        });
    }

    function setupImages(container, hasimg_tag) {
        $("a", container).each(function () {
            // Should not be child of a gallery
            if ($(this).parents(".gallery").length !== 0) return;

            var link = $(this).attr("href");
            if (typeof (link) !== 'undefined' &&
                (link.indexOf(".jpg") !== -1 ||
                link.indexOf(".jpeg") !== -1 ||
                link.indexOf(".png") !== -1 ||
                link.indexOf(".svg") !== -1)) {
                if (hasimg_tag && $(">img", this).length === 0) return;

                $(this).addClass("zoom-image");

                // Replace alignment classes from image element to link element if not in a caption box
                if ($(this).parents(".wp-caption").length === 0) {
                    if ($(">img", this).hasClass("alignleft")) {
                        $(this).addClass("alignleft");
                        $(">img", this).removeClass("alignleft");                        
                    }
                    else if ($(">img", this).hasClass("alignright")) {
                        $(this).addClass("alignright");
                        $(">img", this).removeClass("alignright");                        
                    }
                }

                var title = $(this).attr("title");
                if (typeof (title) === 'undefined' || title.length === 0) {
                    title = $(">img", this).attr("title");
                }

                var caption = $(">img", this).attr("alt");
                if (typeof (caption) === 'undefined' || caption.length === 0) {
                    caption = $(this).parents(".wp-caption").children(".wp-caption-text").text();
                }
                if (typeof (caption) === 'undefined' || caption.length === 0) {
                    caption = $(this).parents(".splash-meta").children(".splash-caption").text();
                }

                if (title === caption) {
                    caption = '';
                }

                var subhtml = '';

                if (typeof (title) !== 'undefined' && title.length > 0) {
                    subhtml = '<h4>' + title + '</h4>';
                }

                if (typeof (caption) !== 'undefined' && caption.length > 0) {
                    subhtml += '<p>' + caption + '</p>';
                }

                var images = [{
                    'src': link,
                    'subHtml': subhtml
                }];

                /*
                $(this).on('onAfterOpen.lg', function(e) {
                    $("#BlogContent").addClass("out-of-focus");
                    $("#TopHeaderContainer").addClass("out-of-focus");
                    $("#FooterContainer").addClass("out-of-focus");
                });

                $(this).on('onBeforeClose.lg', function(e) {
                    $("#BlogContent").removeClass("out-of-focus");
                    $("#TopHeaderContainer").removeClass("out-of-focus");
                    $("#FooterContainer").removeClass("out-of-focus");
                });
                */

                $(this).on("click", function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    $(this).lightGallery({
                        thumbnail: false,
                        counter: false,
                        showThumbByDefault: false,
                        mode: 'lg-tube',
                        hideBarsDelay: 3000,
                        cssEasing: 'cubic-bezier(0.455, 0.030, 0.515, 0.955)',
                        download: false,
                        dynamic: true,
                        dynamicEl: images
                    });
                });
            }
        });
    }


    function setupMenu() {
        let $menu = $("#MenuContainer");
        $("#menu-button").on("click", function () {
            if ($menu.hasClass("open")) {
                $menu.removeClass("open");
                $(this).removeClass("open");
            } else {
                $menu.addClass("open");
                $(this).addClass("open");
            }
        });
    }

    function setupSearch() {
        $("#PostSearchButton").on("click", function () {
            if ($("#s", "#SearchInput").val() !== "") {
                $("#SearchForm").submit();
            } else {
                $("#s", "#SearchInput").focus();
            }
        });

        $("#SearchForm").on("submit", function () {
            if ($("#s", "#SearchInput").val() === "") {
                return false;
            }

            return true;
        });

        $("a.open-search").on("click", function (e) {
            e.preventDefault();
            $("#menu-button").click();
            $("#s", "#SearchInput").focus();
        });        
    }

    function setupLoadMoreButton() {
        $("#LoadMorePosts").on("click", function () {
            var button = $(this),
                data = {
                    'action': 'loadmore',
                    'query': loadmore_params.posts,
                    'page': loadmore_params.current_page,
                    'nonce': loadmore_params.nonce
                };

            $.ajax({
                url: loadmore_params.ajaxurl,
                data: data,
                type: 'POST',
                beforeSend: function () {
                    button.html('Artikelen worden geladen&hellip;').prop('disabled', true);
                },
                success: function (data) {
                    if (data) {
                        var $data = $(data);

                        button.parent().before($data); // insert new posts
                        loadmore_params.current_page++;

                        if (loadmore_params.current_page == loadmore_params.max_page) {
                            button.remove(); // if last page, remove the button
                        }
                    } else {
                        button.remove(); // if no data, remove the button as well
                    }
                },
                error: function (obj, status) {
                    console.log(status);             
                },
                complete: function () {
                    $("#LoadMorePosts").html('Load more posts').prop('disabled', false);
                }
            });
        });
    }    

})();